export default (({
  router
}) => {
  console.log('tongji plugin');
  if (!window) {
    return;
  }
  if (window.location.hostname == 'localhost') {
    console.info('开发环境不需要加载');
    return;
  }

  // 百度统计
  if (HM_ID && typeof window !== 'undefined') {
    var _hmt = _hmt || [];
    (function (d, id) {
      var hm = document.createElement('script');
      hm.src = 'https://hm.baidu.com/hm.js?' + id;
      var s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(hm, s);
    })(document, HM_ID);
  }
  var bp = document.createElement('script');
  var curProtocol = window.location.protocol.split(':')[0];
  if (curProtocol === 'https') {
    bp.src = 'https://zz.bdstatic.com/linksubmit/push.js';
  } else {
    bp.src = 'http://push.zhanzhang.baidu.com/push.js';
  }
  var s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(bp, s);
});